import { Waves } from "lucide-react";
import BeachPhoto from "@/components/yts/BeachPhoto";

/**
 * One beach, in the same shape as every other card on the site: a square photo
 * with the site's own rounding, then the area, the name, the one-line feel and
 * the water reading pinned to the bottom. Tapping it opens the beach's guide.
 */
export default function BeachCard({ beach, onOpen }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={`Open the ${beach.name} guide`}
      className="w-full h-full flex flex-col text-left"
    >
      <span className="relative block aspect-square rounded-[12px] sm:rounded-[16px] overflow-hidden bg-[#F3F4F6]">
        <BeachPhoto beach={beach} />
      </span>

      {/* Rows keep their height with or without data, so neighbouring cards in a
          rail or grid stay exactly the same size. */}
      <span className="block pt-2.5 pb-3 flex-1 flex flex-col">
        <span className="block truncate text-[0.65rem] leading-[15px] tracking-[0.08em] uppercase font-bold text-[#6d6d6a]">
          {beach.area}
        </span>
        <span className="mt-1 block text-[0.98rem] sm:text-[1.05rem] font-extrabold leading-[1.25] tracking-[-0.015em] text-[#171717] line-clamp-2 min-h-[2.5em]">
          {beach.name}
        </span>
        <span className="mt-1 block text-[12px] sm:text-[12.5px] leading-[1.45] text-[#6d6d6a] line-clamp-2 min-h-[2.9em]">
          {beach.vibe}
        </span>
        <span className="mt-auto pt-2 min-h-[28px] flex items-center gap-1.5 text-[12px] font-extrabold text-[#171827]">
          <Waves className="w-3.5 h-3.5 shrink-0 text-[#C9A227]" />
          <span className="truncate">{beach.water}</span>
        </span>
      </span>
    </button>
  );
}